var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnhancePrompt = function SvgEnhancePrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 83 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81.413,
    height: 58.413,
    x: 0.794,
    y: 0.794,
    fill: "#11171D",
    rx: 29.206
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 81.413,
    height: 58.413,
    x: 0.794,
    y: 0.794,
    stroke: "url(#EnhancePrompt_svg__a)",
    strokeWidth: 1.587,
    rx: 29.206
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.19,
    d: "M45.427 22.994c.467-.466.7-.699.958-.81a1.47 1.47 0 0 1 1.165 0c.258.111.492.344.958.81s.699.7.81.957c.16.372.16.794 0 1.166-.111.258-.344.491-.81.957l-3.986 3.986c-.982.982-1.473 1.473-2.088 1.764-.614.29-1.305.359-2.687.495l-.626.062.062-.626c.136-1.382.204-2.073.495-2.688s.782-1.105 1.764-2.087z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.19,
    d: "M36.737 32.38h-1.786a1.389 1.389 0 1 0 0 2.779h7.54a1.389 1.389 0 0 1 0 2.777h-1.786"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EnhancePrompt_svg__a",
    x1: 6.73,
    x2: 84.513,
    y1: 12,
    y2: 43.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2993FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFA93B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5F20"
  })))));
};
export default SvgEnhancePrompt;